'use client'

import { PROVIDER_ROUTES, ROUTES } from '@/core/constants/routes'
import { useAuth } from '@/core/store/auth'
import { AccountType } from '@/core/types/enums/account-type.enum'
import { Button } from '@/core/ui/atoms/button'
import { useReservationStore } from '@/features/reservation/store'
import { useRouter } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'

type Props = {
  tripId: string
}
export const PaymentSuccessActions: React.FC<Props> = ({ tripId }) => {
  const router = useRouter()
  const t = useTranslations()
  const { user, isAuthenticated } = useAuth()
  const reset = useReservationStore(state => state.reset)
  const accountType = user?.accountType

  return (
    <>
      {isAuthenticated && (
        <Button
          onClick={() => {
            reset()
            router.replace(
              accountType === AccountType.CUSTOMER
                ? ROUTES.upcomingTripDetails(tripId)
                : PROVIDER_ROUTES.upcomingTripDetails(tripId),
            )
          }}
        >
          {t('actions.seeDetails')}
        </Button>
      )}
      <Button
        onClick={() => {
          reset()
          router.replace(
            accountType === AccountType.PROVIDER
              ? PROVIDER_ROUTES.trips
              : ROUTES.home,
          )
        }}
        color='sky-blue'
        variant='text'
        className='font-semibold'
      >
        {t('actions.bookAnother')}
      </Button>
    </>
  )
}
